import { useState, useCallback, useEffect } from 'react'
import { CollectImportService } from '../../../services'

const useFileValidation = (collectId, file, shouldValidate) => {
  const [validationResult, setValidationResult] = useState(null)
  const [validating, setValidating] = useState(false)
  const [error, setError] = useState(null)

  const clearValidation = useCallback(() => {
    setValidationResult(null)
    setError(null)
  }, [])

  const reset = useCallback(() => {
    setValidationResult(null)
    setValidating(false)
    setError(null)
  }, [])

  useEffect(() => {
    if (!file || !shouldValidate || validationResult)
      return

    setValidating(true)
    setError(null)

    CollectImportService.validateFile(collectId, file)
      .then(result => {
        setValidationResult(result)
        if (!result.success)
          setError(result.error || 'Erreur lors de la validation du fichier')
      })
      .catch(err => {
        setError(err.message || 'Erreur lors de la validation du fichier')
      })
      .finally(() => {
        setValidating(false)
      })
  }, [file, collectId, shouldValidate, validationResult])

  const getParsedSections = useCallback(() => {
    if (!validationResult?.success)
      return null
    return validationResult.sections
  }, [validationResult])

  return {
    validationResult,
    validating,
    error,
    clearValidation,
    reset,
    getParsedSections
  }
}

export default useFileValidation
